<template>
  <transition name="sheet">
    <div v-if="show" class="sheet-layer">
      <div class="scrim" @click="close" @touchmove.prevent />
      <section class="sheet" role="dialog" aria-modal="true" :aria-label="title">
        <div class="sheet-grab" />
        <header class="sheet-head">
          <div>
            <h2>{{ title }}</h2>
            <p v-if="subtitle">{{ subtitle }}</p>
          </div>
          <button type="button" class="sheet-close" @click="close">收起</button>
        </header>
        <label v-if="searchable" class="search-input">
          <app-icon name="search" />
          <input v-model.trim="query" type="search" :placeholder="'搜索' + title" :aria-label="'搜索' + title" />
        </label>
        <div v-for="group in groups" :key="group.name || 'all'" class="opt-group">
          <h4>{{ group.name }}</h4>
          <div class="opts">
            <button v-for="item in group.items" :key="String(item.value)" type="button" class="opt" :class="{ on: isOn(item.value) }" :aria-pressed="isOn(item.value) ? 'true' : 'false'" @click="pick(item.value)">
              <span>{{ item.label }}</span>
              <small v-if="item.hint && item.hint !== group.name">{{ item.hint }}</small>
              <span class="tick" :class="{ square: multiple }"><app-icon name="check" /></span>
            </button>
          </div>
        </div>
        <p v-if="!groups.length" class="sheet-empty">没有找到“{{ query }}”</p>
        <div v-if="multiple" class="sheet-foot">
          <button type="button" class="button full" @click="close">
            {{ count ? '确定（已选 ' + count + '）' : '确定' }}
          </button>
        </div>
      </section>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    show: Boolean,
    title: { type: String, default: '请选择' },
    subtitle: String,
    value: { type: [String, Number, Array], default: '' },
    // { value, label, group?, hint? }
    options: { type: Array, default: () => [] },
    multiple: Boolean,
    searchable: Boolean
  },
  data() {
    return { query: '' }
  },
  computed: {
    groups() {
      const query = this.query
      const items = query
        ? this.options.filter(
            item => String(item.label).indexOf(query) >= 0 || String(item.hint || '').indexOf(query) >= 0
          )
        : this.options
      const groups = []
      const named = {}
      items.forEach(item => {
        const name = item.group || ''
        if (!named[name]) {
          named[name] = { name, items: [] }
          groups.push(named[name])
        }
        named[name].items.push(item)
      })
      return groups
    },
    count() {
      return Array.isArray(this.value) ? this.value.length : 0
    }
  },
  watch: {
    show(value) {
      document.body.classList.toggle('modal-open', value)
      if (!value) this.query = ''
    }
  },
  beforeDestroy() {
    if (this.show) document.body.classList.remove('modal-open')
  },
  methods: {
    isOn(value) {
      if (Array.isArray(this.value)) return this.value.some(item => String(item) === String(value))
      return this.value !== '' && this.value !== null && this.value !== undefined && String(this.value) === String(value)
    },
    pick(value) {
      if (!this.multiple) {
        this.$emit('input', value)
        this.close()
        return
      }
      const list = (this.value || []).slice()
      const index = list.map(String).indexOf(String(value))
      if (index >= 0) list.splice(index, 1)
      else list.push(value)
      this.$emit('input', list)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/picker-sheet.vue